import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';

class Privacy extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
  }
  
  render() {
    return (
      <div className="member-policy card-policy popup">

        <div className="rule">
          <div className="rule_list">
            <div className="rule_item">
              <br/>
              <h3 style={{textAlign: "center"}}>&lt;개인정보처리방침&gt;</h3>
              <br/>
              토즈 스터디센터ㆍ스터디랩ㆍ스터디카페의 원활한 서비스 제공을 위하여 아래와 같이 개인정보를 수집ㆍ이용 및 제공하고자 합니다.
              <br/><br/>

              <h4>1. 개인정보 수집 항목 및 이용 목적, 보유 기간</h4>
              <table style={{width: "100%"}}>
                  <colgroup>
                      <col style={{ width: "38%" }} />
                      <col style={{ width: "38%" }} />
                      <col style={{ width: "24%" }} />
                  </colgroup>
                  <thead>
                      <tr>
                          <th>항목</th>
                          <th>수집목적</th>
                          <th>보유기간</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>
                              신청서 기재사항(성명, 연락처 등),<br/>
                              지문등록, CCTV촬영                                                            
                          </td>
                          <td>
                              운영관리<br/>
                              서비스제공
                          </td>
                          <td>
                              최종 이용일로부터 3년                                                                                                                    
                          </td>
                      </tr>
                  </tbody>
              </table>

              <h4>2. 개인정보의 수집방법</h4>
              1) 고객이 서면으로 가입신청서 작성, 센터 내 비치된 전자기기를 통해 회원 등록을 진행하는 경우에 한해 개인정보를 수집합니다.<br/>
              <br/><br/>

              <h4>3. 개인정보의 이용 및 제3자 제공</h4>
              1) 회원 등록 시 수집하는 개인정보는 토즈 본사가 관리하는 시스템에 안전하게 저장됩니다.<br/>
              2) 토즈 전국 센터 간 원활한 이용을 위해 이용 센터 변경 시, 보유 기간 이내라면 회원 정보가 신규 방문 지점에 공유됩니다.<br/>
              - 공유 시점 : 회원 본인이 신규 지점에서 본인인증을 하는 경우<br/>
              - 기존 이용하던 센터에는 이용 내역에 대한 관리를 위해 최종 이용일로부터 3년간 보유됩니다.<br/>
              3) 토즈에 등록된 회원의 개인정보는 어떠한 경우에도 제3자에게 제공되지 않습니다.
              <br/><br/>

              <h4>4. 개인정보의 파기</h4>
              1) 수집한 개인정보의 수집·이용 목적이 달성되거나 보유기간이 종료되는 경우 해당 정보를 지체없이 파기합니다.<br/>
              2) 서면으로 기재된 개인정보의 경우 분쇄기로 분쇄하거나 소각하며 전자적 방법으로 저장된 개인정보의 경우에는 그 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.<br/>
              3) 다만, 토즈 지점의 원활한 운영 활동을 하기 위해 개인정보보호법을 준수하는 범위 내에서 파기 이전 고객의 정보는 익명 또는 가명 처리, 휴대번호 삭제 등의 개인식별이 불가능하게 처리하여 보관할 수 있습니다.
              <br/><br/>

              <h4>5. 고객의 권리와 행사방법</h4>
              1) 회원은 언제든지 회사가 보유한 개인정보, 개인정보의 이용 내역, 수집·이용에 대한 동의 내역을 열람하거나 정정할 수 있습니다. 해당 개인정보의 오류가 있거나 보존기간이 경과한 것으로 판명되는 등 정정·삭제를 할 필요가 있다고 인정되는 경우에 회사는 지체없이 수정합니다.<br/>
              2) 회사는 대리인이 방문하여 열람 · 증명을 요구하는 경우에는 적법한 위임을 받았는지 확인할 수 있는 위임장 및 본인의 인감증명서와 대리인의 신분증 등을 제출 받아 정확히 대리인 여부를 확인합니다.<br/>
              3) 회원이 타인 정보의 도용이나 침해, 허위정보를 입력하는 경우 서비스 해지 및 회원자격이 상실될 수 있으며 법 등 관련 법령에 따라 처벌받을 수 있습니다.
              <br/><br/>

              <h4>6. 개인정보 수집·이용에 대한 동의 철회</h4>
              1) 개인정보의 수집·이용에 동의한 내용을 언제든지 철회할 수 있습니다. 동의철회는 개인정보보호책임자 및 담당자에게 서면, 전화, 이메일 등으로 연락하면 하실 수 있으며, 회사는 지체없이 개인정보의 삭제 등 필요한 조치를 시행합니다.<br/>
              - 이메일 : duke@greenlamp.kr
              <br/><br/>

              <h4>7. 개인정보보호를 위한 기술적·관리적 대책</h4>
              1) 회사는 개인정보를 처리함에 있어 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.<br/>
              가. 접속기록의 위 · 변조 방지 조치를 취하고 있습니다.<br/>
              나. 개인정보는 그 종류에 따라 관련 법령이 요구하는 수준의 암호화 저장 또는 전송 시 암호화 기술의 적용하여 관리합니다.<br/>
              다. 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있으며, 백신프로그램을 주기적으로 업데이트하고 갑작스러운 바이러스 출현 시에 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.<br/>
              라. 암호알고리즘을 이용하여 네트워크상 개인정보를 안전하게 전송하는 보안장치(SSL 등)를 채택하고 있습니다.<br/>
              마. 해킹 등 외부 침입에 대비하여 각 서버마다 침입차단시스템 및 취약점분석시스템을 이용하여 보안에 최선을 다하고 있습니다.<br/>
              2) 관리적 대책<br/>
              가. 회사는 개인정보 보호에 관한 내부관리계획을 수립, 시행하고 있습니다.<br/>
              나. 회사는 개인정보에 대한 접근권한을 필요 · 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.<br/>
              ① 고객을 직접 상대하여 상담 업무를 수행하는 자(이용센터 인포데스크)<br/>
              ② 개인정보보호책임자 및 그 담당자 등 개인정보관리업무를 수행하는 자<br/>
              ③ 기타 업무상 개인정보의 처리가 불가피한 자<br/>
              다. 회사는 개인정보를 처리하는 직원을 대상으로 새로운 보안기술 습득 및 개인정보 보호의무 등에 관해 정기적인 사내 교육을 실시합니다.<br/>
              라. 회사는 직원 입사 시 보안서약서를 통하여 사람에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수 여부를 감사하기 위한 내부절차를 마련하고 있습니다.<br/>
              마. 개인정보 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지도록 하며 입사 및 퇴사 후 개인정보 사고에 관한 책임을 명확히 합니다.<br/>
              바. 개인정보와 일반 데이터는 혼합하여 보관하지 않고 분리하여 보관합니다.<br/>
              사. 회사는 내부 관리자의 실수나 기술관리상 사고로 인하여 개인정보의 도난, 유출, 변조, 훼손이 유발될 경우 적절한 대책과 보상을 강구합니다.
              <br/><br/>

              <h4>8. 개인정보보호 책임자</h4>
              <table>
                  <colgroup>
                      <col style={{ width: "50%" }} />
                      <col style={{ width: "50%" }} />
                  </colgroup>
                  <thead>
                      <tr>
                          <th className="left">개인정보보호 담당자</th>
                          <th className="left">개인정보보호 책임자</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td className="left">
                              성명 : 나의윤<br/>
                              소속 : IT팀<br/>
                              전화 : 1588-5935<br/>
                              메일 : duke@greenlamp.kr
                          </td>
                          <td className="left">
                              성명 : 류현석<br/>
                              소속 : IT팀<br/>
                              전화 : 1588-5935<br/>
                              메일 : hs.ryu@greenlamp.kr
                          </td>
                      </tr>
                  </tbody>
              </table>
              <br/>
              <p>※ 토즈 전국 지점 간 원활한 이용을 위해 이용 센터 변경 시 회원 정보가 신규 방문 지점에도 공유됩니다.</p>
              <p>※ 위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다.</p>
              <p>※ 동의를 거부할 경우 토즈를 이용하실 수 없습니다.</p>
              <br/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Privacy;